<template>
  <catalog-tree-panel>
  <template v-slot:title>
  <div class="row">
    <div class="panel-title space">{{ $t('tools.catalogTree.title') }}</div>
    <q-btn
      flat
      dense
      text-color="black"
      icon="layers_clear"
      @click="_onClick()"
    >
      <q-tooltip>
        {{ $t('tools.cleanMap.title') }}
      </q-tooltip>
    </q-btn>
    <q-btn
      flat
      dense
      text-color="black"
      icon="add"
      to="addcustomlayer"
    >
      <q-tooltip>
        {{ $t('tools.addCustomLayer.title') }}
      </q-tooltip>
    </q-btn>
  </div>
  </template>
  </catalog-tree-panel>
</template>

<script>
import { CatalogTreePanel, lib } from '@giscube/geoportal'
const { onToolClick } = lib.toolUtils

import { QBtn, QTooltip } from 'quasar'

export default {
  components: {
    CatalogTreePanel, QBtn, QTooltip
  },
  beforeRouteEnter: CatalogTreePanel.beforeRouteEnter,
  beforeRouteUpdate: CatalogTreePanel.beforeRouteUpdate,
  methods: {
    _onClick () {
      return onToolClick('cleanMap', this)
    }
  }
}
</script>
